import { Button, Group } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { useState } from 'react';
import { Download, X } from 'tabler-icons-react';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ErrorResponse } from '../../type/error-response.types';
import {
  ExportTransactionsRequest,
  RetrieveAllTransactionsRequest,
} from '../../type/retrieve-transaction.types';

interface Props {
  transactionDetailsRequest: RetrieveAllTransactionsRequest;
}
const ExportButton = (props: Props) => {
  const [isLoading, setIsLoading] = useState(false);
  const { transactionDetailsRequest } = props;
  const axiosPrivate = useAxiosPrivate();

  const downloadData = async () => {
    setIsLoading(true);
    try {
      const request: ExportTransactionsRequest = {
        filters: {
          partnerId: transactionDetailsRequest.filters.partnerId!,
          ...transactionDetailsRequest.filters,
        },
        detailedFilters:transactionDetailsRequest.detailedFilters
      };
      const response = await axiosPrivate.post(
        '/web/transactions/export',
        request,
        {
          responseType: 'blob',
        }
      );

      const startNoTime = transactionDetailsRequest.filters.startDate
        .toString()
        .split(' ');
      const endNoTime = transactionDetailsRequest.filters.endDate
        .toString()
        .split(' ');

      const formattedStartDate = startNoTime[0].split('-').join('');
      const formattedEndDate = endNoTime[0].split('-').join('');
      const fileName = `${formattedStartDate}-${formattedEndDate}`;

      const blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      link.click();
    } catch (err: any) {
      let responseObj = await err.response.data.text();

      const error: ErrorResponse = JSON.parse(responseObj);
      showNotification({
        id: 'failed-to-retrieve-partners-data',
        message:
          error.error ||
          err.response?.request.statusText ||
          'An Unexpected Error Occurred',
        icon: <X size={16} />,
        color: 'red',
        autoClose: 10000,
      });
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Button
      px='xs'
      onClick={() => {
        downloadData();
      }}
      loading={isLoading}
      leftIcon={<Download size={15} />}
    >
      <Group spacing='xs'>Export Data</Group>
    </Button>
  );
};

export default ExportButton;
